<template>
  <div class="user-permission-config">
    <div class="rj-page-card">
      <div class="rj-page-card__title">
        用户菜单权限配置
      </div>
      <div class="rj-page-card__content">
        <el-tabs v-model="activeTab" @tab-click="onTabClick">
          <el-tab-pane label="用户权限配置" name="user">
            <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm" @submit.native.prevent>
              <el-form-item label="用户名称:" prop="userId">
                <el-select
                  v-model="searchForm.userId"
                  class="user-id-select"
                  filterable
                  remote
                  clearable
                  reserve-keyword
                  placeholder="输入姓名模糊匹配"
                  :remote-method="remoteUserMethod"
                  :loading="userLoading"
                  @change="onUserChange"
                >
                  <el-option
                    v-for="item in userOptions"
                    :key="item.userID"
                    :label="formatUserLabel(item)"
                    :value="item.userID"
                  />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="loading" @click="queryDetail">
                  查询
                </el-button>
                <el-button type="default" :disabled="loading" @click="resetPage">
                  重置
                </el-button>
              </el-form-item>
            </el-form>

            <div v-if="queried" v-loading="loading" class="config-body">
              <div class="toolbar">
                <div class="tip">
                  当前配置用户：<b>{{ currentUserLabel || currentUserId || '-' }}</b>
                  <span class="sub">（保存将全量覆盖该用户菜单与按钮权限）</span>
                </div>
                <div>
                  <el-button type="default" :disabled="!menuOptions.length" @click="selectAll">
                    全选
                  </el-button>
                  <el-button type="default" :disabled="!menuOptions.length" @click="clearAll">
                    清空
                  </el-button>
                  <el-button type="primary" :loading="saving" @click="saveConfig">
                    保存
                  </el-button>
                </div>
              </div>

              <el-input
                v-model.trim="filterText"
                clearable
                placeholder="筛选菜单码 / 标题"
                class="filter-input"
              />

              <el-table :data="filteredMenuOptions" border style="width: 100%; margin-top: 12px">
                <el-table-column label="勾选" width="70" align="center">
                  <template v-slot="{ row }">
                    <el-checkbox v-model="row.checked" />
                  </template>
                </el-table-column>
                <el-table-column prop="perssimionCode" label="菜单码" min-width="220" />
                <el-table-column prop="title" label="菜单标题" min-width="180">
                  <template v-slot="{ row }">
                    {{ row.title || '-' }}
                  </template>
                </el-table-column>
                <el-table-column label="按钮操作权限" width="140" align="center">
                  <template v-slot="{ row }">
                    <el-switch
                      v-model="row.buttonFlag"
                      :disabled="!row.checked"
                      active-text="开"
                      inactive-text="关"
                    />
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <el-tab-pane label="菜单管理" name="menu">
            <div class="toolbar">
              <div class="tip">
                当前系统已有菜单列表；新增会登记到权限库供授权勾选，与具体用户无关。
              </div>
              <div>
                <el-button type="primary" @click="openMenuDialog()">
                  新增菜单
                </el-button>
                <el-button :loading="menuLoading" @click="loadManagedMenus">
                  刷新
                </el-button>
              </div>
            </div>

            <el-input
              v-model.trim="menuFilterText"
              clearable
              placeholder="筛选菜单码 / 标题"
              class="filter-input"
            />

            <el-table v-loading="menuLoading" :data="filteredManagedMenus" border style="width: 100%; margin-top: 12px">
              <el-table-column type="index" label="序号" width="60" />
              <el-table-column prop="perssimionCode" label="菜单码" min-width="220" />
              <el-table-column prop="menuTitle" label="菜单标题" min-width="180">
                <template v-slot="{ row }">
                  {{ row.menuTitle || '-' }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100" fixed="right">
                <template v-slot="{ row }">
                  <el-button type="text" @click="openMenuDialog(row)">
                    编辑
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <el-dialog
      :title="menuDialogTitle"
      :visible.sync="menuDialogVisible"
      width="480px"
      :close-on-click-modal="false"
      @closed="resetMenuForm"
    >
      <el-form ref="menuForm" :model="menuForm" :rules="menuRules" label-width="90px">
        <el-form-item label="菜单码" prop="perssimionCode">
          <el-input
            v-model.trim="menuForm.perssimionCode"
            clearable
            placeholder="需与前端路由 name 一致"
          />
        </el-form-item>
        <el-form-item label="菜单标题" prop="menuTitle">
          <el-input v-model.trim="menuForm.menuTitle" clearable placeholder="如：用户菜单权限配置" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="menuDialogVisible = false">
          取消
        </el-button>
        <el-button type="primary" :loading="menuSaving" @click="confirmMenuSave">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  searchUserPermissionUser,
  getUserPermissionMenuCatalog,
  getUserPermissionDetail,
  saveUserPermissionConfig,
  getPermissionMenuList,
  addPermissionMenu,
  updatePermissionMenu
} from '@/API';
import { layoutRoute } from '@/router/router';

let userSearchTimer;

function buildRouteTitleMap (routes = [], map = {}) {
  routes.forEach((route) => {
    if (route && route.name) {
      map[route.name] = (route.meta && route.meta.title) || route.name;
    }
    if (route && route.children && route.children.length) {
      buildRouteTitleMap(route.children, map);
    }
  });
  return map;
}

export default {
  name: 'UserPermissionConfig',
  data () {
    return {
      activeTab: 'user',
      searchForm: {
        userId: ''
      },
      loading: false,
      saving: false,
      userLoading: false,
      queried: false,
      currentUserId: '',
      currentUserName: '',
      filterText: '',
      menuOptions: [],
      userOptions: [],
      titleMap: buildRouteTitleMap(layoutRoute),
      menuLoading: false,
      menuSaving: false,
      managedMenus: [],
      menuFilterText: '',
      menuDialogVisible: false,
      menuForm: {
        id: null,
        perssimionCode: '',
        menuTitle: ''
      },
      menuRules: {
        perssimionCode: [
          { required: true, message: '请输入菜单码', trigger: 'blur' },
          {
            pattern: /^[A-Za-z][A-Za-z0-9_]*$/,
            message: '菜单码需以字母开头，仅含字母数字下划线',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  computed: {
    filteredMenuOptions () {
      const keyword = (this.filterText || '').toLowerCase();
      if (!keyword) {
        return this.menuOptions;
      }
      return this.menuOptions.filter((item) => {
        const code = (item.perssimionCode || '').toLowerCase();
        const title = (item.title || '').toLowerCase();
        return code.includes(keyword) || title.includes(keyword);
      });
    },
    filteredManagedMenus () {
      const keyword = (this.menuFilterText || '').toLowerCase();
      if (!keyword) {
        return this.managedMenus;
      }
      return this.managedMenus.filter((item) => {
        const code = (item.perssimionCode || '').toLowerCase();
        const title = (item.menuTitle || '').toLowerCase();
        return code.includes(keyword) || title.includes(keyword);
      });
    },
    currentUserLabel () {
      if (!this.currentUserId) {
        return '';
      }
      if (this.currentUserName) {
        return `${this.currentUserName}（${this.currentUserId}）`;
      }
      return this.currentUserId;
    },
    menuDialogTitle () {
      return this.menuForm.id ? '编辑菜单' : '新增菜单';
    }
  },
  created () {
    this.loadCatalog();
  },
  methods: {
    onTabClick (tab) {
      if (tab.name === 'menu') {
        this.loadManagedMenus();
      }
    },
    formatUserLabel (item) {
      if (!item) {
        return '';
      }
      if (item.userName && item.userID) {
        return `${item.userName}（${item.userID}）`;
      }
      return item.userName || item.userID || '';
    },
    remoteUserMethod (query) {
      const keyword = (query || '').trim();
      if (!keyword) {
        this.userOptions = [];
        return;
      }
      if (userSearchTimer) {
        window.clearTimeout(userSearchTimer);
      }
      userSearchTimer = setTimeout(() => {
        this.userLoading = true;
        searchUserPermissionUser(keyword).then((res) => {
          this.userLoading = false;
          const json = res.data;
          if (json && json.status === '200') {
            this.userOptions = json.data || [];
          } else {
            this.userOptions = [];
          }
        }).catch(() => {
          this.userLoading = false;
          this.userOptions = [];
        });
      }, 200);
    },
    onUserChange (val) {
      const selected = this.userOptions.find((item) => item.userID === val);
      this.currentUserName = selected ? (selected.userName || '') : '';
      this.queried = false;
    },
    async loadCatalog () {
      try {
        const { data } = await getUserPermissionMenuCatalog();
        if (!data || data.status !== '200') {
          return;
        }
        const list = data.data || [];
        this.menuOptions = list.map((item) => ({
          perssimionCode: item.perssimionCode,
          perssimionId: item.perssimionId,
          title: item.menuTitle || this.titleMap[item.perssimionCode] || '',
          checked: false,
          buttonFlag: false
        }));
      } catch (e) {
        // 全局拦截已提示
      }
    },
    async loadManagedMenus () {
      this.menuLoading = true;
      try {
        const { data } = await getPermissionMenuList();
        if (data && data.status === '200') {
          this.managedMenus = (data.data || []).map((item) => ({
            ...item,
            menuTitle: item.menuTitle || this.titleMap[item.perssimionCode] || ''
          }));
        }
      } finally {
        this.menuLoading = false;
      }
    },
    resetChecked () {
      this.menuOptions.forEach((item) => {
        item.checked = false;
        item.buttonFlag = false;
      });
    },
    openMenuDialog (row) {
      if (row) {
        this.menuForm = {
          id: row.id,
          perssimionCode: row.perssimionCode || '',
          menuTitle: row.menuTitle || ''
        };
      } else {
        this.resetMenuForm();
      }
      this.menuDialogVisible = true;
    },
    resetMenuForm () {
      this.menuForm = {
        id: null,
        perssimionCode: '',
        menuTitle: ''
      };
      if (this.$refs.menuForm) {
        this.$refs.menuForm.clearValidate();
      }
    },
    confirmMenuSave () {
      this.$refs.menuForm.validate(async (valid) => {
        if (!valid) {
          return;
        }
        const payload = {
          id: this.menuForm.id,
          perssimionCode: this.menuForm.perssimionCode.trim(),
          menuTitle: (this.menuForm.menuTitle || '').trim()
        };
        this.menuSaving = true;
        try {
          const req = this.menuForm.id ? updatePermissionMenu : addPermissionMenu;
          const { data } = await req(payload);
          if (data && data.status === '200') {
            this.$message.success(this.menuForm.id ? '更新成功' : '新增成功');
            if (payload.menuTitle) {
              this.titleMap[payload.perssimionCode] = payload.menuTitle;
            }
            this.menuDialogVisible = false;
            await this.loadManagedMenus();
            await this.loadCatalog();
          }
        } finally {
          this.menuSaving = false;
        }
      });
    },
    async queryDetail () {
      if (!this.searchForm.userId) {
        this.$message.warning('请选择用户');
        return;
      }
      if (!this.menuOptions.length) {
        await this.loadCatalog();
      }
      this.loading = true;
      try {
        const { data } = await getUserPermissionDetail(this.searchForm.userId);
        if (!data || data.status !== '200') {
          return;
        }
        const detail = data.data || {};
        const codeSet = new Set(detail.perssimionCodeList || []);
        const buttonMap = {};
        (detail.perssimionButtonList || []).forEach((btn) => {
          if (btn && btn.permissionCode) {
            buttonMap[btn.permissionCode] = !!btn.buttonFlag;
          }
        });
        codeSet.forEach((code) => {
          if (!this.menuOptions.some((item) => item.perssimionCode === code)) {
            this.menuOptions.push({
              perssimionCode: code,
              perssimionId: null,
              title: this.titleMap[code] || '',
              checked: false,
              buttonFlag: false
            });
          }
        });
        this.menuOptions.forEach((item) => {
          item.checked = codeSet.has(item.perssimionCode);
          item.buttonFlag = item.checked ? !!buttonMap[item.perssimionCode] : false;
        });
        this.currentUserId = this.searchForm.userId;
        const selected = this.userOptions.find((item) => item.userID === this.searchForm.userId);
        if (selected && selected.userName) {
          this.currentUserName = selected.userName;
        }
        this.queried = true;
      } finally {
        this.loading = false;
      }
    },
    resetPage () {
      this.searchForm.userId = '';
      this.currentUserId = '';
      this.currentUserName = '';
      this.filterText = '';
      this.userOptions = [];
      this.queried = false;
      this.resetChecked();
    },
    selectAll () {
      this.filteredMenuOptions.forEach((item) => {
        item.checked = true;
      });
    },
    clearAll () {
      this.filteredMenuOptions.forEach((item) => {
        item.checked = false;
        item.buttonFlag = false;
      });
    },
    async saveConfig () {
      if (!this.currentUserId) {
        this.$message.warning('请先查询用户');
        return;
      }
      const selected = this.menuOptions.filter((item) => item.checked);
      try {
        await this.$confirm(
          `将全量覆盖用户【${this.currentUserLabel || this.currentUserId}】的菜单权限（共 ${selected.length} 项），是否继续？`,
          '提示',
          { type: 'warning' }
        );
      } catch (e) {
        return;
      }
      this.saving = true;
      try {
        const payload = {
          userId: this.currentUserId,
          perssimionCodeList: selected.map((item) => item.perssimionCode),
          menuItemList: selected.map((item) => ({
            perssimionCode: item.perssimionCode,
            perssimionId: item.perssimionId == null ? null : Number(item.perssimionId)
          })),
          perssimionButtonList: selected
            .filter((item) => item.buttonFlag)
            .map((item) => ({
              permissionCode: item.perssimionCode,
              buttonFlag: true
            }))
        };
        const { data } = await saveUserPermissionConfig(payload);
        if (data && data.status === '200') {
          this.$message.success('保存成功');
          await this.queryDetail();
        }
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.tip .sub {
  margin-left: 8px;
  color: #909399;
  font-size: 12px;
}
.filter-input {
  width: 320px;
}
.config-body {
  margin-top: 8px;
}
.user-id-select {
  width: 420px;
}
</style>
<style>
.user-permission-config .searchBoxLine .user-id-select .el-input {
  max-width: none;
  width: 420px;
}
</style>
